import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId1,
    checkbox1,
    certificate,
    fullName,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId1.name]: "",
  [taxpayerName.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [fullName.name]: "",
  [timeSign.name]: "",
  [checkbox1.name]: false,
};

export default initialValues;
